export default __webpack_public_path__ + "static/media/air-freight.998f7ede.svg";